export default __webpack_public_path__ + "static/media/active-momentum-card-banner.05e45ef4.png";